import * as XLSX from 'xlsx/xlsx.mjs';
import type { StatisticsSeries } from '@/types/series';
import type { StatisticsData } from '@/types/statisticsApi';
import type { SeriesDefinition } from '@/types/statisticsSeriesDefs';
import { fmt } from '@/utils/dates';
import type { Compare } from '../types';
import { getPeriodLabel } from './getPeriodLabel';

type SheetRow = (string | number)[];
type WorkSheetData = SheetRow[];

export const exportChartToExcel = <Series extends StatisticsSeries, C extends Compare>(
  data: StatisticsData<Series, C>[],
  series: SeriesDefinition<Series>[],
  title: string,
  queryLabels: string,
  comparisonLabels: string[],
) => {
  if (!data) {
    console.log('Query contains no data.');
    return {
      message: 'Query contains no data.',
      success: false,
    };
  }

  let worksheetData: WorkSheetData = [];
  let sheetRow: SheetRow;
  worksheetData.push([queryLabels]);

  sheetRow = ['År', 'Period', 'Start', 'Slut'];
  const labelRow = ['', '', '', ''];
  series.forEach((s) => {
    data.forEach((_, i) => {
      labelRow.push(`${comparisonLabels[i]}`);
      sheetRow.push(`${s.title}`);
    });
  });
  worksheetData.push(labelRow);
  worksheetData.push(sheetRow);

  const dataRows: WorkSheetData = [];
  data[0].periods.forEach((p, i) => {
    const periodLabel = getPeriodLabel(p.granularity, p.end);

    sheetRow = [fmt(p.end, 'yyyy'), periodLabel, p.start, p.end];
    series.forEach((s) => {
      data.forEach((d) => {
        d.rows.forEach((q) => {
          const data = q.cols[s.slug].values[i];
          sheetRow.push(data ?? '');
        });
      });
    });
    dataRows.push(sheetRow);
  });
  worksheetData = worksheetData.concat(dataRows);

  const workbook = XLSX.utils.book_new();
  [{ name: title, data: worksheetData }].forEach((s: { name: string; data: WorkSheetData }) => {
    const worksheet = XLSX.utils.aoa_to_sheet(s.data);
    XLSX.utils.book_append_sheet(workbook, worksheet, s.name);
  });

  XLSX.writeFile(workbook, `${title}: ${queryLabels}.xlsx`);

  return {
    message: 'Done',
    success: true,
  };
};
